import React, { useState, useEffect } from "react";
import { modifySelectedCred } from "../../../redux/actions/credActions";
import { useSelector, useDispatch } from "react-redux";
import { TYPE_OPTIONS } from "../../../common/constants/core/oauth2.constants";
import GrantTypeAuthorizationCodeForm from "./GrantTypeAuthorizationCodeForm";
import GrantTypePasswordForm from "./GrantTypePasswordForm";
import ClientCredentialsForm from "./ClientCredentialsForm";
import Select from "@atlaskit/select";
import { GrantType } from "../../../common/interfaces/credentials/Credentials";

const Oauth2Page = () => {
  const dispatch = useDispatch();
  const selectedCred = useSelector((state) => state.auth.selectedCred);
  const [type, setType] = useState(TYPE_OPTIONS[0]);

  useEffect(() => {
    if (type !== selectedCred?.data?.config?.grantType && selectedCred?.data?.config?.grantType !== undefined) {
      setType(TYPE_OPTIONS.find((v) => v.value === selectedCred.data.config.grantType));
    }
  }, [selectedCred]);
  const onTypeChange = (e) => {
    if (!selectedCred.data) {
      selectedCred.data = { config: { grantType: e.value } };
    } else if (selectedCred.data && !selectedCred.data.config) {
      selectedCred["data"] = { config: { grantType: e.value } };
    } else {
      selectedCred.data.config["grantType"] = e.value;
    }

    dispatch(modifySelectedCred(selectedCred));
    setType(e);
  };
  return (
    <>
      <Select
        spacing={"default"}
        className="ihub-action-method-select"
        value={type}
        options={TYPE_OPTIONS}
        placeholder="Select credential type"
        onChange={onTypeChange}
      />
      {type && type.value === GrantType.AUTHORIZATION_CODE && <GrantTypeAuthorizationCodeForm />}
      {type && type.value === GrantType.RESOURCE_OWNER_PASSWORD_CREDENTIALS && <GrantTypePasswordForm />}
      {type && type.value === GrantType.CLIENT_CREDENTIALS && <ClientCredentialsForm />}
    </>
  );
};
export default Oauth2Page;
